import { EscalationType } from '@aloft/toolkit-shared';

export type ValidationStep =
  | 'Global'
  | 'OrderDetails'
  | 'Analysis'
  | 'Market'
  | 'Comparables'
  | 'Commentary'
  | 'Reconciliation'
  | 'Adjustments';

export enum ValidationKey {
  // AlertValidation
  Alerts = 'alerts',
  AlertsCommentary = 'alertsCommentary',

  // OrderDetailsValidation
  ParcelNumber = 'parcelNumber',
  Zoning = 'zoning',
  ZoningCompliance = 'zoningCompliance',
  LegalDescription = 'legalDescription',
  NeighborhoodName = 'hoa',
  EffectiveDate = 'effectiveDate',
  IntendedUsers = 'intendedUsers',
  IntendedUse = 'intendedUse',
  LocationType = 'locationType',
  PropertyInterest = 'propertyInterest',
  PropertyInterestOther = 'propertyInterestOther',
  // AnalysisValidation
  OpinionOfSiteValue = 'opinionOfSiteValue',
  CostQuality = 'costQuality',

  // CommentaryValidation - Market Conditions
  EstimatedDemand = 'estimatedDemand',
  EstimatedExposureTime = 'estimatedExposureTime',
  MarketConditionCommentary = 'marketConditionCommentary',

  // CommentaryValidation - Prior Sales
  PriorSalesCommentary = 'priorSalesCommentary',

  // ReconciliationValidation
  TotalCostToCure = 'totalCostToCure',
  TotalCostToCureCommentary = 'totalCostToCureCommentary',
  OpinionOfMarketValue = 'opinionOfMarketValue',
  OpinionOfAfterRepairValue = 'opinionOfAfterRepairValue',
  TotalRenovationBudget = 'totalRenovationBudget',
  ReconciliationCommentary = 'reconciliationCommentary',
  AivReconciliationCommentary = 'aivReconciliationCommentary',
  ArvReconciliationCommentary = 'arvReconciliationCommentary',
  HighestAndBestUseCommentary = 'highestAndBestUseCommentary',
  RevisionCommentary = 'revisionCommentary',
  AlternativeComparablesCommentary = 'alternativeComparablesCommentary',
  FeasibilityCommentary = 'feasibilityCommentary',
  AivDiscrepancyCommentary = 'aivDiscrepancyCommentary',
  ArvDiscrepancyCommentary = 'arvDiscrepancyCommentary',
  ValueTypes = 'valueTypes',

  // GlobalValidation
  IsEscalated = 'isEscalated',
}

export enum ValidationErrorType {
  REQUIRED = 'required',
  INVALID = 'invalid',
}

export type OrganizedValidationErrors = {
  Alerts: ValidationErrors;
  OrderDetails: ValidationErrors;
  Analysis: ValidationErrors;
  Market: ValidationErrors;
  Commentary: ValidationErrors;
  Reconciliation: ValidationErrors;
  Global: ValidationErrors;
  Comparables: ValidationErrors;
  Adjustments: ValidationErrors;
};

export type ValidationError = { type: ValidationErrorType; message: string };

export type ValidationErrors = Partial<Record<ValidationKey, ValidationError>>; // nested record, eg. { order: { zoningCompliance: ValidationError } }

export type StopAndCallIssue = {
  title: string;
  description: string;
  justification?: string;
  fieldName?: string;
  apiEscalationType?: EscalationType;
};
